export enum ROLES {
  OPERATOR = 'OPERATOR',
  OPERATOR_MANAGER = 'OPERATOR_MANAGER',
  PSAP = 'PSAP',
  PSAP_MANAGER = 'PSAP_MANAGER',
  PSAP_INTEGRATOR = 'PSAP_INTEGRATOR',
  MINIST_PROJECT_MANAGER = 'MINIST_PROJECT_MANAGER',
  STATE_AUTHORITY = 'STATE_AUTHORITY',
  ADMIN_APNF = 'ADMIN_APNF',
  WORLDLINE = 'WORLDLINE',
  SUPER_ADMIN = 'SUPER_ADMIN'
}
